import { render, staticRenderFns } from "./ConsentementCommunication.vue?vue&type=template&id=75751aa1"
import script from "./ConsentementCommunication.vue?vue&type=script&lang=js"
export * from "./ConsentementCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports